<template>
  <div class="main-content-container container-fluid px-4">
    <!-- Page Header -->
    <div class="page-header row no-gutters py-4">
      <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle">Dashboard</span>
        <h3 class="page-title">User Setup</h3>
      </div>
    </div>

    <!-- Default Light Table -->
    <div class="row">
      <div class="col">
        <div class="card card-small mb-4">
          <div class="card-header border-bottom">
            <h6 class="m-0">
              <router-link :to="{ name: 'UsersetupAdd'}">
                <button
                  class="btn btn-md btn-primary"
                  style="background-color:white;color:black;"
                >Add New</button>
              </router-link>
            </h6>
          </div>
          <div class="card-body p-0 pb-3 text-center">
            <div class="row">
              <div class="col">
                <div class="grid-row" layout="row top-stretch">
                  <div class="grid-cell">
                    <paginator
                      :source="Usersetup.DataModel.Data.UsersetupList"
                      :filter="Usersetup.GridInfo.UsersetupInfoGrid.AdditionalInfo.filter"
                      :page-size="Usersetup.GridInfo.UsersetupInfoGrid.AdditionalInfo.pageSize"
                      data-intro="Use the paginator to page data for easier viewing"
                      data-step="10"
                      data-position="top"
                    >
                      <template scope="page">
                        <datatable
                          id="data-table-main"
                          :source="page.data"
                          :filterable="false"
                          :striped="Usersetup.GridInfo.UsersetupInfoGrid.AdditionalInfo.striped"
                          :editable="Usersetup.GridInfo.UsersetupInfoGrid.AdditionalInfo.editable"
                          :line-numbers="Usersetup.GridInfo.UsersetupInfoGrid.AdditionalInfo.lineNumbers"
                        >
                          <datatable-column
                            v-for="column in Usersetup.GridInfo.UsersetupInfoGrid.columns"
                            :id="column.id"
                            :label="column.label"
                            :width="column.width"
                            :sortable="column.sortable"
                            :groupable="column.groupable"
                            :formatter="column.formatter"
                          ></datatable-column>
                          <template slot="UserName" scope="cell">
                            <label
                              for="UserName"
                              style="width:100% !important"
                              @click="GetById(cell.row)"
                              class="Grid-field align-left form-control-sm gridLink"
                            >{{cell.row.UserName}}</label>
                          </template>
                          <!-- <template slot="ProfitAmount" scope="cell">
                                        <label for="ProfitAmount" style="width:100% !important" :Id="cell.row.Id + '_max'" class="Grid-field align-left form-control-sm"> {{cell.row.ProfitAmount}} </label>
                          </template>-->
                          <template slot="Password" scope="cell">
                            <label
                              for="Password"
                              style="width:100% !important"
                              class="Grid-field align-left form-control-sm"
                            >{{cell.row.Password}}</label>
                          </template>
                          <!-- <template slot="Status" scope="cell">
                                        <label for="Status" style="width:100% !important" :Id="cell.row.Id + '_max'" class="Grid-field align-left form-control-sm"> {{cell.row.Status}} </label>
                          </template>-->
                          <!-- <template slot="Status.Name" scope="cell">
                            <label
                              for="Status"
                              style="width:100% !important"
                              class="Grid-field align-left form-control-sm"
                            >{{cell.row.Status.Name}}</label>
                          </template>-->
                        </datatable>
                      </template>
                    </paginator>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script src="https://checkout.razorpay.com/v1/checkout.js"></script>
<script>
import Utilities from "@/Utilities/Utilities";
import axios from "axios";
export default {
  name: "Usersetup",
  data() {
    return {
      Usersetup: {
        PageType: "Master", // Master, Transaction, Dashboard, Tabb edDashboard
        PageLoad: true, // block/none
        DataModel: {
          Data: {
            Id: 0,
            Username: null,
            UserName: null,
            Password: null,
            ConfirmPassword: null,
            CustomerId: 0,
            CreatedBy: 1,
          },
          UIData: {},
        },
        PageState: "Default", // Default, Changed/Dirty, Submitted, PageLoading Dirty means some values are changed in the page
        TabInfo: {
          SelectedTabIndex: 0,
          NumberOfTabs: 0,
        },
        SessionInfo: {
          SessionTimeout: false,
          AuthToken: "",
          SessionID: "",
          PageInfo: {
            ClientId: 0,
            userId: 0,
            WareHouseId: 0,
          },
        },
        GridInfo: {
          UsersetupInfoGrid: {
            filterInfo: {
              PageSize: 0,
              PageNumber: 0,
              HotelId: 0,
              CustomerName: null,
            },
            AdditionalInfo: {
              striped: true,
              editable: false,
              lineNumbers: false,
              filter: null,
              currency: "USD",
              dateFormat: "D MMMM YYYY",
              selected: [],
              pageSize: 15,
              totalRows: 0,
            },
            columns: [
              {
                id: "UserName",
                label: "UserName",
                width: null,
                sortable: true,
                groupable: true,
                aggregators: [],
              },

              {
                id: "Password",
                label: "Password",
                width: null,
                sortable: true,
                groupable: true,
                aggregators: [],
              },
              // {
              //   id: "ConfirmPassword",
              //   label: "ConfirmPassword",
              //   width: null,
              //   sortable: true,
              //   groupable: true,
              //   aggregators: [],
              // },
              // {
              //     id: "Intrest",
              //     label: "Intrest",
              //     width: null,
              //     sortable: true,
              //     groupable: true,
              //     aggregators: [

              //     ],
              // },
              // {
              //     id: "Status",
              //     label: "Status",
              //     width: null,
              //     sortable: true,
              //     groupable: true,
              //     aggregators: [

              //     ],
              // },
            ],
          },
        },
        Events: {
          EventRaised: "Submitted", // Saved, Submitted, Cancelled, AutoCompletionTextChanged,
          PageToNavigateWhenSubmitted: "", // We can go back to dashboard or stay on the Same page or to a specific page
        },
        ValidationInfo: {},
        ErrorInfo: [
          {
            ErrorID: 1,
            ErrorName: "",
            ErrorMessage: "",
          },
        ],
        Masters: {},
        Modal: {},
        CharRestrict: {},
      },
    };
  },
  mounted() {
    this.ListUsersetup();
  },
  methods: {
    ListUsersetup() {
      let vm = this;
      var Token = sessionStorage.getItem("Token");
      this.Usersetup.DataModel.Data.Token = Token;
      var CustomerId = sessionStorage.getItem("CustomerId");
      this.Usersetup.DataModel.Data.CustomerId = CustomerId;
      this.Usersetup.DataModel.Data.CRUD = "List";
      var dataString = JSON.stringify(this.Usersetup.DataModel.Data);
      console.log(this.Usersetup.DataModel.Data);
      axios
        .post(
          "APIScript/PHP/APIService/UserSetup/UserSetupService.php",
          dataString
        )
        .then(function (response) {
          // return response;
          if (response.data.ErrorInfo == null) {
            vm.Usersetup.DataModel.Data.UsersetupList = response.data.Result;

            vm.Usersetup.DataModel.Data.UsersetupList.map(function (
              value,
              key
            ) {
              value.Amount = Utilities.TransactionCurrencyFormat(value.Amount);
            });
          } else if (response.data.ErrorInfo == "Invalid Attempt") {
            this.$router.push({ name: "Login" });
          }
        })
        .catch(function (response) {
          console.log(response.data.ErrorInfo);
        });
    },
    GetById(data) {
      let vm = this;
      sessionStorage.setItem("SelectedUsersetupID", data.Id);
      // this.$router.push("/Commodity/CommodityEdit");
      this.$router.push({ name: "UsersetupView" });
    },
  },
};
</script>
